import React from 'react';

import styles from './assets/styles/styles.module.scss';

import { ANSWER_TEXT } from '~/constants/count_const';

class Answer extends React.Component {
  constructor(props) {
    super(props);
    this.mainRef = React.createRef();
  }

  async componentDidMount() {
    await this.mainRef.current.scrollIntoView();
    document.documentElement.scrollTop -= 180;
  }

  render() {
    const {
      questionTitle,
      inputTitle,
      placeholder,
      checkResultButtonText,
    } = ANSWER_TEXT;
    const {
      onAnswerButtonClick,
      onAnswerChange,
      answer
    } = this.props;
    return (
      <div className={styles.answer} ref={this.mainRef}>
        <div className={styles.container}>
          <h3 className={styles['question-title']}>{questionTitle}</h3>
          <label className={styles['input-container']}>
            <span className={styles['input-label-caption']}>{inputTitle}</span>
            <input className={styles['input-itself']} placeholder={placeholder} onChange={onAnswerChange} value={answer}/>
          </label>
          <button className={`${styles['check-result-button']} iq-tests-button`} onClick={onAnswerButtonClick}>
            {checkResultButtonText}
          </button>
        </div>
      </div>
    );
  }
}

export default Answer;
